module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/financial-unit-lvl1-75.97838763.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/financial-unit-lvl1-75.png
// module id = 3527
// module chunks = 11